import { useState, useEffect } from 'react';

interface TelegramUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  language_code?: string;
  photo_url?: string;
}

interface UseTelegramUserReturn {
  user: TelegramUser | null;
  isNewUser: boolean;
  isLoading: boolean;
}

export const useTelegramUser = (): UseTelegramUserReturn => {
  const [user, setUser] = useState<TelegramUser | null>(null);
  const [isNewUser, setIsNewUser] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initUser = async () => {
      try {
        // Получить данные из Telegram WebApp
        const tg = window.Telegram?.WebApp;

        if (tg?.initDataUnsafe?.user) {
          const tgUser = tg.initDataUnsafe.user;

          const userData: TelegramUser = {
            id: tgUser.id,
            first_name: tgUser.first_name,
            last_name: tgUser.last_name,
            username: tgUser.username,
            language_code: tgUser.language_code,
            photo_url: tgUser.photo_url,
          };

          setUser(userData);

          // Проверить на backend - новый ли пользователь
          const response = await fetch('/app-api/user/check', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `tma ${tg.initData}`,
            },
            body: JSON.stringify({ telegram_id: tgUser.id }),
          });

          if (response.ok) {
            const data = await response.json();
            setIsNewUser(data.is_new_user);
          }
        } else {
          // Web mode or dev mode — don't set mock data in production
          // Web auth is handled by useAuth hook separately
          if (import.meta.env.DEV) {
            console.warn('Telegram WebApp not available, using mock data');
            setUser({
              id: 123456789,
              first_name: 'Иван',
              last_name: 'Петров',
              username: 'testuser',
              language_code: 'ru',
            });
            setIsNewUser(true);
          }
          // In production web mode: user stays null, App.tsx uses webUser instead
        }
      } catch (error) {
        console.error('Error initializing user:', error);
      } finally {
        setIsLoading(false);
      }
    };

    initUser();
  }, []);

  return { user, isNewUser, isLoading };
};
